<template>
  <div class="Head">
    <div class="title">
      <div class="big-title">极光智模</div>
      <div class="small-title">一款基于模具生产的管理系统</div>
      <div class="copyright">@Copyright treasure</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style  scoped>
.title {
  margin: 15% 30px 1% 30px;
  padding: 0 50px 0 50px;
  color:#6f5499;
}
.big-title {
  font-size: 80px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  
}
.small-title {
  font-size: 15px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
.copyright {
  font-size: 10px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
</style>